'use strict';

angular.module('mobile-apps')
	.directive('displayStringLength',['$compile', '$http', '$templateCache', function($compile, $http, $templateCache) {
		return {
			scope:
			{
				base : '=',
				data : '=',
				maxLength : '=',
				isMasterLang : '='
			},
			templateUrl: 'modules/mobile-apps/views/display-string-length.client.view.html',

			link: function (scope, elem, attrs) {

				scope.displayMaxLength = undefined;

				scope.getTextColor = function() {
					if (scope.displayMaxLength) {
						var stringLength = 0;
						if (scope.data) {
							stringLength = scope.data.length;
						}

						if (stringLength <= scope.displayMaxLength) {
							// String length ok
							return '#34b334';
						} else {
							// String to long
							return '#d9534f';
						}
					}

					// No string length defined
					return '#555555';
				}


				function refreshDisplayData() {
					if (scope.maxLength === undefined || scope.maxLength === 0) {
						// Depends on what kind of data it is
						if (scope.isMasterLang) {
							// In master-language it represents also deactivated
							scope.displayMaxLength = undefined;
						} else {
							// In other-language it takes the length of the base
							// language string
							//scope.displayMaxLength = 99; // TEMP JUST FOR TESTING
							if (scope.base) {
								scope.displayMaxLength = scope.base.length;
							} else {
								// If there is no master-language and no base
								// we do not display the max-length
								scope.displayMaxLength = undefined;
							}
						}
					} else if (scope.maxLength === -1) {
						// No length limit
						scope.displayMaxLength = undefined;
					} else {
						// Length got set manually
						scope.displayMaxLength = scope.maxLength;
					}
				}


				scope.$watch('base', function() {
					refreshDisplayData();
				});

				scope.$watch('maxLength', function() {
					refreshDisplayData();
				});

			}
		};
	}]);
